import React from 'react';
import { motion } from 'framer-motion';
export function MomentoPantalon() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="bg-white py-16 md:py-24" data-id="element-98">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="max-w-4xl mx-auto" data-id="element-100">
          <h2 className="font-serif text-3xl md:text-4xl text-forest mb-8 text-center" data-id="element-101">
            El Momento del Pantalón
          </h2>
          <div className="md:columns-2 gap-8 space-y-6 text-lg text-forest/80 leading-relaxed" data-id="element-102">
            <p data-id="element-103">
              Estás en tu habitación. Es viernes por la noche o quizás un lunes
              por la mañana antes de ir a trabajar. Eliges ese pantalón que
              siempre te ha hecho sentir segura, profesional, atractiva. Subes
              la tela por las piernas, llega a la cadera y, de repente, la
              realidad golpea: falta una pulgada. El botón no llega.
            </p>
            <p data-id="element-104">
              Este es el "Momento del Pantalón". Es el instante en que te das
              cuenta de que lo que solía funcionar —esa ensalada rápida,
              saltarse la cena, o caminar un poco más— simplemente ha dejado de
              ser efectivo.
            </p>
            <p className="text-terracotta font-semibold italic border-l-4 border-terracotta pl-4" data-id="element-105">
              "Pero si estoy comiendo lo mismo de siempre, ¿por qué antes me
              quedaba y ahora no?"
            </p>
          </div>
        </div>
      </div>
    </motion.section>;
}